import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"; 
import { Region, RegionClient, WorkingGroupClient, WorkingGroups } from "../../../../web-api-client";
import { WorkingGroupsCreationComponent } from "./workingGroups-creation/workingGroups-creation.component";
import { ConfirmModalComponent } from "../../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../../modals/failed-modal/failed-modal.component";
import { WorkingGroupEditComponent } from "./workingGroups-edit/workingGroups-edit.component";
import { forkJoin } from "rxjs";
import { ToastrService } from "ngx-toastr";


@Component({
  selector: 'app-workingGroup',
  templateUrl: './workingGroup.component.html',
  styleUrls: ['./workingGroup.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class WorkingGroupComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedObject: WorkingGroups;
  public allObjects: WorkingGroups[];
  public regions:Region[] = [];

  // Assuming you already have a property for all the objects
  public searchQuery: string = '';
  filteredObjects: WorkingGroups[] = [];




  constructor(private readonly changeDetectionRef: ChangeDetectorRef, private readonly modalService: NgbModal,public client:WorkingGroupClient,public regionClient:RegionClient){

  }

  ngOnInit(): void {

    this.loadData();

  }


  public filterObjects() {
    if (this.searchQuery) {
      this.filteredObjects = this.allObjects.filter(object =>
        object.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredObjects = this.allObjects;
    }
  }

  public loadData() {

    forkJoin([this.client.getList(), this.regionClient.getList()]).subscribe(([allObjects, regions]) => {
      this.allObjects = allObjects;
      this.filteredObjects = allObjects;
      this.regions = regions;
      this.isLoaded = true;
      this.changeDetectionRef.detectChanges();
    }
    );
     
    }

  public onRegionName(id: number): string{
      let region = this.regions.find(r => r.id == id);
    return region ? region.title : 'Не е избран';
  }

  public onSelected(object: WorkingGroups){
   if (this.isSelected(object)){
    this.selectedObject = null;
  }
  else{

     this.selectedObject = object;
  }
 }

  public isSelected(object: WorkingGroups):boolean{
    return this.selectedObject == object;
 }

public onCreation():void{
  let modalRef = this.modalService.open(WorkingGroupsCreationComponent, {});

  modalRef.componentInstance.onClose.subscribe(r => {

    this.loadData();

  });

}


public onDelete(): void {


    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.client.remove(this.selectedObject.id).subscribe(r => {
          this.allObjects = this.allObjects.filter(d => d.id != this.selectedObject.id);
          this.filteredObjects = this.allObjects.slice(0);
          this.changeDetectionRef.detectChanges();
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(WorkingGroupEditComponent);
    modalRef.componentInstance.editObject = this.selectedObject;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.loadData();

    });

    }

}
